import * as Types from '../../__generated__/api/types';

import gql from '@tv2-player/unifiedplayer/gqlToString';
export type CustomerTypeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CustomerTypeQuery = {
  customerType: {
    __typename: 'CustomerType';
    id: string;
    products: Array<{
      __typename: 'CustomerProduct';
      id: string;
      providerId: string;
      providerType: Types.ProviderType;
    }>;
  } | null;
};

export const CustomerType = gql`
  query CustomerType {
    customerType {
      id
      products {
        id
        providerId
        providerType
        __typename
      }
    }
  }
`;
